import * as actions from '../utils/Constants';
import { getProjects } from './Projects';
const api = `${process.env.REACT_APP_API_HOST}api/project/`;

export const getProject = (id) => {
    return {
        type: actions.GET_PROJECT,
        payload: fetch(api + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        })
    }
}

export const updateProject = (project) => {
    return dispatch => dispatch({
        type: actions.UPDATE_PROJECT,
        payload: fetch(api, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(project),
        }).then(res => {
            dispatch(getProjects());
            return res.json();
        })
    })
}

export const setField = (field, value) => ({
    type: actions.SET_PROJECT_FIELD,
    field,
    payload: value
});
